import React from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'
import { useParams } from 'react-router-dom'
import EmployeeAttendanceList from '../components/EmployeeAttendanceList';
import EmployeeLeaveRequestList from '../components/EmployeeLeaveRequestList';

function EmployeeAttendancePage() {
    const {id} = useParams();
  return (
    <AppLayout>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-6'>
                    <EmployeeAttendanceList employeeId={id} />
                </div>
                <div className='col-md-6'>
                    <EmployeeLeaveRequestList employeeId={id} />
                </div>
            </div>
        </div>
    </AppLayout>
  )
}

export default EmployeeAttendancePage